<template>
    <div class="@container pb-8">
      <div
        class="
            grid 
            grid-cols-1
            @md:grid-cols-2
            @2xl:grid-cols-3
            @3xl:grid-cols-3
            @4xl:grid-cols-4
            @6xl:grid-cols-5
            gap-x-6
            gap-y-6
        "
      >
        <div 
            v-for="campaign in campaigns.data" :key="campaign.id"
        >
          <PubCampaignCard class="duration-500" :campaign="campaign"  :class="isLoading ? 'skeleton opacity-40' : ''"></PubCampaignCard>
        </div>
      </div>
      <div
        class="w-100 py-4"
        v-if="
          campaigns &&
            campaigns.paginatorInfo &&
            campaigns.paginatorInfo.hasMorePages
        "
      >
        <XButton
            v-if="!isLoading"
          class="block m-auto"
          @click="onClickButton"
          :is-loading="isLoading"
          >LOAD MORE</XButton>
      </div>
      <div v-else-if="isLoading"  class="py-8 flex justify-center items-center text-base-content/25">
          <v-icon class="ov-spin" name="ri-loader-5-line" height="1em" width="1em" scale="1.5" />
      </div>
    </div>
  </template>
  
  <script setup>
  import PubCampaignCard from '@/components/common/PubCampaignCard.vue';

  import { useCampaignsStore } from "@/stores/campaigns.js"

  const { gridPagination, updateGridPagination } = useCampaignsStore();


  const props = defineProps({
    campaigns: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  });
  
  const emit = defineEmits(['loadMore']);
  
  const onClickButton = () => {
    updateGridPagination({
      ...gridPagination,
      first: gridPagination.first + 20
    })
  };
  </script>